import React from "react";
import Warning from "../../assets/img/warning.png";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";

const Logout = ({ openDialog, setopenDialog }) => {

  const logout = async () => {
    // Will redirect to Okta to end the session then redirect back to the configured `postLogoutRedirectUri`
    localStorage.clear();
    window.location.href = `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`;
  };

  return (
    <div id="logout-popup">
      <Dialog
        open={openDialog}
        onClose={() => {
          setopenDialog(false);
        }}
        id="logout-modal"
      >
        <DialogTitle id="alert-dialog-title">
          <div className="logout-header">
            <img src={Warning} alt="Warning" />
            <h3>Warning</h3>
            <p>Do you want to logout?</p>
          </div>
        </DialogTitle>
        <DialogActions
          style={{
            padding: "24px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <button
            className="logout-popup-btn primary-btn"
            onClick={() => {
              logout();
              setopenDialog(false);
            }}
          >
            Yes
          </button>
          <button
            className="logout-popup-btn secondary-btn"
            onClick={() => {
              setopenDialog(false);
            }}
          >
            No
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Logout;
